<template>
  <div class="exam-detail">
    <v-container v-if="!isLoaded" >
      <v-mockup widget="article-detail" />
    </v-container>
    <main v-else>
      <v-container>
        <v-breadcrumb :options="[
          { title: 'Início', to: '/' },
          { title: 'Exames', to: '/exames' },
          { title: exam.title, },
        ]" />
      </v-container>
      <page-top v-bind="exam">
        <v-btn model="color-a"
          :small="true"
          tag="router-link"
          :to="`/pre-agendamento?exame=${$route.params.examId}`">
            Pré-agendamento para este exame
        </v-btn>
      </page-top>
      <section class="subexams">
        <v-container>
          <p>Cada exame possui um preparo específico.<br>Escolha abaixo o exame para ver seu preparo.</p>
          <search-input label="Busque um sub-exame" @search="onSearch($event)" @clear="onClear()" />
          <router-link v-for="(subexam, index) in subexams" :key="index"
            :to="`/exames/${$route.params.examId}/sub-exame/${subexam.id}`">
            <b>{{subexam.title}}</b>
            <span>ver preparo <i class="icon-triangle"></i></span>
          </router-link>
        </v-container>
        <v-btn model="color-a"
          :small="true"
          tag="router-link"
          :to="`/pre-agendamento?exame=${$route.params.examId}`">
            Pré-agendamento para {{exam.title}}
        </v-btn>
      </section>
    </main>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import PageTop from '@/components/layout/PageTop.vue';
import Container from '@/components/layout/Container.vue';
import Heading from '@/components/uikit/text/Heading.vue';
import Mockup from '@/components/uikit/mockup/Mockup.vue';
import Btn from '@/components/uikit/Btn.vue';
import Breadcrumb from '@/components/widgets/Breadcrumb.vue';
import SearchInput from '@/components/widgets/SearchInput.vue';

export default {
  name: 'ExamDetail',
  components: {
    'page-top': PageTop,
    'v-container': Container,
    'v-heading': Heading,
    'v-mockup': Mockup,
    'v-btn': Btn,
    'v-breadcrumb': Breadcrumb,
    'search-input': SearchInput,
  },
  metaInfo() {
    return {
      title: this.isLoading ? 'Carregando...' : this.exam.title,
      meta: [
        { name: 'og:title', content: this.exam.title, vmid: 'og:title' },
        { name: 'og:description', content: this.exam.subtitle, vmid: 'og:description' },
      ],
    };
  },
  computed: {
    ...mapState({
      exam: state => state.exams.exam,
    }),
    ...mapGetters({
      isLoading: 'exams/isLoading',
      isLoaded: 'exams/isLoaded',
    }),
  },
  data() {
    return {
      subexams: [],
    };
  },
  methods: {
    onSearch(search) {
      this.subexams = this.exam.subexams.filter(item => item.title.match(search));
    },
    onClear(search) {
      this.subexams = this.exam.subexams;
    },
  },
  async created() {
    await this.$store.dispatch('exams/fetchExam', this.$route.params.examId)
      .then((resp) => {
        if (resp.errors) {
          this.$router.replace('/404');
          return;
        }
        this.subexams = this.exam.subexams;
      });
  },
  destroyed() {
    this.$store.commit('exams/setExam', {});
  },
};
</script>

<style lang="scss" scoped>
$component: '.exam-detail';
#{$component} {
  padding-top: $section-gutter / 2;
  .page-top {
    /deep/ h2:nth-child(2) {
      color: $color-a;
    }
  }
  .icon-triangle {
    display: inline-block;
    margin-left: $gutter;
    font-size: $font-size-xs;
    transform: rotate(-90deg);
    color: $color-a;
  }
  .subexams {
    padding: $section-gutter 0 $section-margin;
    background-color: $bg-gray;
    text-align: center;
    .container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-row: auto;
      grid-gap: 0 $gutter-xxl;
      margin-bottom: $section-gutter / 2;
      text-align: left;
      @media screen and (max-width: #{$brakepoint-medium}) {
        display: block;
        p {
          text-align: center;
        }
      }
      .search-input {
        margin-bottom: $gutter-xxl;
      }
      p {
        align-self: end;
        margin: 0 0 $gutter-xxl;
        font-size: $font-size-xl;
        color: $color-sys-e;
      }
      a {
        display: grid;
        grid-template-columns: auto 120px;
        border-bottom: 1px solid $color-sys-h;
        align-items: center;
        padding: $gutter-l 0 $gutter;
        text-decoration: none;
        color: $color-sys-b;
        font-size: $font-size-xl;
        transition: color $transition-duration $transition-timing-function,
          color $transition-duration $transition-timing-function;
        padding-left: $gutter;
        span {
          text-wrap: no-wrap;
          color: $color-sys-e;
          font-size: $font-size-l;
        }
        &:hover {
          background-color: rgba($color-sys-k, 0.4);
          color: $color-a;
        }
      }
    }
  }
}
</style>
